/**
 * select2 Component
 *
 * @file custom select2.js
 */


import 'select2/dist/css/select2.min.css';
import $ from "jquery";
import 'select2';
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";



const customSelect = (() => {
  
  const buttonChangeDataUrl = () => {
    document.addEventListener('DOMContentLoaded', function() {
      const linkElements = document.querySelectorAll('.pl-button.aqua.data-sp-tooltip');
  
      linkElements.forEach(linkElement => {
          linkElement.addEventListener('click', function(event) {
              event.preventDefault();
  
              const userAgent = navigator.userAgent.toLowerCase();
              let targetLink;
  
              if (userAgent.includes('iphone') || userAgent.includes('ipad')) {
                  targetLink = this.getAttribute('data-mobile-link-ios');
              } else if (userAgent.includes('android')) {
                  targetLink = this.getAttribute('data-mobile-link-android');
              } else {
                  targetLink = this.getAttribute('data-desktop-link');
              }
  
              window.open(targetLink, '_blank'); // Yeni sekmede açılır
          });
      });
    });
  };

  const defaultFancybox = () => {
    const cookieModalClass = document.getElementById("cookie-dialog-content");
    Fancybox.bind('[data-fancybox]', {
      // Custom options for all galleries
      dragToClose: false,  // Sürüklemeyi devre dışı bırak
      on: {
        close: (fancybox, slide) => {
          cookieModalClass.classList.remove("d-block");
          cookieModalClass.classList.add("d-none");
        }
    }
    }); 
    $(".cookie-accept").on("click", function(){
      Fancybox.close();
    });
  };


  const defaultcustomSelect = () => {
    //if language sorgusu buraya gelecek html lang koduyla değişkene aktarılacak 
    $('.calculate-select').select2({
      theme: "calculate-custom-option-select",
      language: {
          noResults: function () {
              // Dillere göre yazı getireceğiz
              return "Sonuç bulunamadı";
          }
      },
      templateResult: function (option) {
          if (!option.id) {
              return option.text;
          }
          var $option = $(
              '<span><img src="assets/images/' + option.text + '.png" class="img-flag" /> ' + option.text + '</span>'
          );
          return $option;
      },
      templateSelection: function (option) {
          if (!option.id) {
              return option.text;
          }
          var $option = $(
              '<span><img src="assets/images/' + option.text + '.png" class="img-flag" /> ' + option.text + '</span>'
          );
          return $option;
      }
    }).on('select2:open', function(e){
        // Dillere göre yazı getireceğiz
        $('.select2-search__field').attr('placeholder', 'Arama yap');
    });
  };
  const defaultcustomSelectMini = () => {
    //if language sorgusu buraya gelecek html lang koduyla değişkene aktarılacak 
    $('.calculate-select-mini').select2({
      theme: "calculate-custom-option-select-mini",
      minimumResultsForSearch: Infinity
    });
  };

  const defaultOnlyNumber = () => {
    const inputs = document.querySelectorAll('.inp-only-number');

    // Her bir input için dinleyici ekle
    inputs.forEach(input => {
        input.addEventListener('input', function() {
            // Girilen değeri kontrol et
            let value = this.value;

            // Sadece rakam içeren bir değere izin ver
            value = value.replace(/[^0-9]/g, '');

            // Input değerini güncelle
            this.value = value;
        });
    });
  };

  const init = () => {
    buttonChangeDataUrl();
    defaultFancybox();
    defaultcustomSelect();
    defaultcustomSelectMini();
    defaultOnlyNumber();
  };

  return {
    init,
  };
})();

export default customSelect;
